<template>
  <div class="chart-box" ref="chartBox" :style="getChartStyle">
    <v-chart
      v-if="showChart && !isEmptyData"
      id="chart"
      class="chart"
      :option="getOption"
      :init-options="getInitOptions"
      ref="pictorialBar"
      @click="dispatchEventCallback('click', $event)"
      @dblclick="dispatchEventCallback('dblclick', $event)"
      @mouseover="dispatchEventCallback('mouseover', $event)"
      @mouseout="dispatchEventCallback('mouseout', $event)"
      @mouseup="dispatchEventCallback('mouseup', $event)"
      @mousedown="dispatchEventCallback('mousedown', $event)"
      @touchstart="dispatchEventCallback('touchstart', $event)"
      @touchend="dispatchEventCallback('touchend', $event)"
      theme="ovilia-green"
      autoresize
    />
    <!-- 空数据 -->
    <div class="null-data" v-if="isEmptyData">
      <img src="../../../../assets/images/img-null-data-light.png" alt="" />
      <p>暂无数据</p>
    </div>
  </div>
</template>

<script>
import { hasProperty } from "utils"
import parentMixin from "components/bigScreenComponents/base"
import handleChartData from "utils/updateData/chart/handleChartData.js"
import plugins from "./plugin"

export default {
  mixins: [parentMixin, plugins, handleChartData],
  name: "cxPictorialBar",
  data() {
    return {
      autoPlayToolTipTimer: null,
      tooltipIndex: 0,
      eventCallbackList: {
        click: ["test"],
        dblclick: [],
        mouseover: [],
        mouseout: [],
        mouseup: [],
        mousedown: [],
        touchstart: [],
        touchend: []
      }
    }
  },
  watch: {
    "options.chartOption.series": function (newVal, oldVal) {
      // console.log("newVal :>>", newVal)
      if (this.options.chartOption?.yAxis?.axisLabel?.rich) {
        const barData = newVal.find(item => item.type === "bar")
        const keys = Object.keys(this.options.chartOption.yAxis.axisLabel.rich)
        if (barData.data.length !== keys.length - 2) {
          const rankKays = keys
            .filter(item => item !== "rank" && item.includes("rank"))
            .sort((a, b) => Number(a[a.length - 1]) - Number(b[b.length - 1]))
          const lastRank = rankKays[rankKays.length - 1]
          if (lastRank) {
            const newRank = JSON.parse(JSON.stringify(this.options.chartOption.yAxis.axisLabel.rich[lastRank]))
            console.log(this.ids)
            this.$changeOptionsEV(
              newRank,
              "chartOption.yAxis.axisLabel.rich.rank" + (Number(lastRank[lastRank.length - 1]) + 1),
              false,
              false,
              false,
              true
            )
            //兼容外接数据大于初始数据，柱状图样式7
            if (barData.data.length > keys.length - 2) {
              for (let i = keys.length - 2; i < barData.data.length; i++) {
                const newRank = JSON.parse(JSON.stringify(this.options.chartOption.yAxis.axisLabel.rich[lastRank]))
                console.log("newRank", newRank)
                this.$changeOptionsEV(
                  newRank,
                  "chartOption.yAxis.axisLabel.rich.rank" + Number(i),
                  false,
                  false,
                  false,
                  true
                )
              }
            }
          }
        }
      }
      if (newVal.length !== oldVal.length) {
        this.$refs.pictorialBar.setOption(this.options.chartOption, true)
      } else if (newVal[0].animationDuration !== oldVal[0].animationDuration) {
        this.initOption = this.options.initOptions
      }

      // 数据改变时 更新最大最小值的背景
      for (var i = 0; i < newVal.length; i++) {
        if (newVal[i].maximumSet) {
          if (newVal[i]?.data !== oldVal[i]?.data) {
            // 初始值
            let maxValue = newVal[i].data[0].value
            let minValue = newVal[i].data[0].value
            let maxIdx = 0,
              minIdx = 0,
              oldMaxIdx = 0,
              oldMinIdx = 0
            newVal[i].data.forEach((item, index) => {
              if (Number(item.value) > Number(maxValue)) {
                maxValue = item.value
                maxIdx = index
              }
              if (Number(item.value) < Number(minValue)) {
                minValue = item.value
                minIdx = index
              }
              item.type === "max" ? (oldMaxIdx = index) : ""
              item.type === "min" ? (oldMinIdx = index) : ""
            })
            let params = newVal[i]
            // 重置最大值背景色
            if (oldMaxIdx != maxIdx) {
              params.data[maxIdx].itemStyle = params.barMaxColor
              params.data[maxIdx].type = "max"
              if (oldMaxIdx != minIdx) {
                params.data[oldMaxIdx].itemStyle = {}
                params.data[oldMaxIdx].type = ""
              }
            }
            // 重置最小值背景色
            if (oldMinIdx != minIdx) {
              params.data[minIdx].itemStyle = params.barMinColor
              params.data[minIdx].type = "min"
              if (oldMinIdx != maxIdx) {
                params.data[oldMinIdx].itemStyle = {}
                params.data[oldMinIdx].type = ""
              }
            }
            this.$changeOptionsEV(params, "chartOption.series." + i, false, false, false, true)
          }
        }
      }
      // 解决编辑页数据少于预览页时自定义展示数量不生效的问题
      if (this.isBigScreenPreview()) {
        this.$nextTick(() => {
          this.changeDatazoomFunc(this.options.chartOption.dataZoomSet)
        })
      }
      if(this.options.numberCount){
        this.checkFormatterValue()
      }
    },
    "options.chartOption.series.0.roundCap": function (newVal, oldVal) {
      if (newVal !== undefined && oldVal !== undefined) {
        this.reloadChart()
      }
    },
    "options.chartOption.series.0.realtimeSort": function (newVal, oldVal) {
      if (newVal !== undefined && oldVal !== undefined) {
        this.reloadChart()
      }
    },
    getDragStatus(newVal, oldVal) {
      this.getDragStatusHandle(newVal, oldVal, "pictorialBar")
    },
    isAutoPlayToolTip(newVal, oldVal) {
      setTimeout(() => {
        this.autoplayTooltip()
      }, 1000)
    },
    autoPlayToolTipIntervalTime(newVal, oldVal) {
      if (this.isAutoPlayToolTip) {
        setTimeout(() => {
          this.autoplayTooltip()
        }, 500)
      }
    },
    showChart() {
      setTimeout(() => {
        this.autoplayTooltip()
      }, 500)
    },
    refreshedChart(newVal) {
      if (newVal) {
        this.$refs.pictorialBar?.setOption(this.getOption)
        setTimeout(() => {
          this.autoplayTooltip()
        }, 500)
      } else {
        this.$refs.pictorialBar?.clear()
      }
    },
    "options.chartOption.dataZoomSet": {
      deep: true,
      handler(newVal, oldVal) {
        this.changeDatazoomFunc(newVal, oldVal)
      }
    }
  },
  mounted() {
    this.refreshFunc()
    this.autoplayTooltip()
    this.scrollBarAuto()
    const chartOption = this.options.chartOption
    this.checkFormatterValue()
    if (
      chartOption?.series?.length === 0 ||
      (chartOption?.xAxis?.type === "category" && chartOption?.xAxis?.data?.length === 0) ||
      (chartOption?.yAxis?.type === "category" && chartOption?.yAxis?.data?.length === 0) ||
      (chartOption?.radiusAxis?.type === "category" && chartOption?.radiusAxis?.data?.length === 0) ||
      (chartOption?.series?.length !== 0 && chartOption?.series[0]?.data?.length === 0)
    ) {
      this.hasData = false
    }
  },
  destroyed() {
    clearInterval(this.autoPlayToolTipTimer)
    this.autoPlayToolTipTimer = null
  },
  methods: {
    test(e) {
      console.log(e)
    },
    checkVal(opt, newVal, oldVal) {
      newVal.forEach((item, index) => {
        //如果当前echarts使用的数据没有在realvalue字符串的开头，则说明realvalue被改变了
        if (item.realValue.indexOf(item.value) !== 0) {
        }
      })
    },
    autoplayTooltip() {
      clearInterval(this.autoPlayToolTipTimer)
      this.autoPlayToolTipTimer = null
      if (!this.options.isAutoPlayToolTip) {
        return
      }
      // 自动播放 tooltip 初始化
      let myChart = this.$refs.pictorialBar?.chart
      let data = this.getOption.series[0].data
      this.autoPlayToolTipTimer = setInterval(() => {
        myChart._api.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: this.tooltipIndex
        })
        this.tooltipIndex++
        if (this.tooltipIndex > data.length - 1) {
          this.tooltipIndex = 0
        }
      }, this.options.autoPlayToolTipIntervalTime)
    }
  }
}
</script>

<style scoped>
.chart {
  height: 100%;
}
</style>
